
  import { controls } from "./controls";
  import React, { Component } from "react";
  
  
  
  const help = {
    label: "Menu Help",
    starting: true,
    url: "help",
    pageLabel: "Menu Help",
    pageType: "history",
    filter: [
      ...controls.displayText({ tab: "filter", label: "Search", width: "col-sm-2" }),
      ...controls.text({ tab: "filter", isRequired: true, star: true ,name:"search"}),
      
    ],
    form: [],
    history: {
        perPage: 10,
        filterable: true,
        reportHeader: "HELP",
        pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
        displayColumns: [
          
          {
            Header: "Options",
            accessor: "option",
          },
          {
            Header: "Descriptions",
            accessor: "description",
          },
        ]
      }
  };
  
  export default help;
  